import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ModalComponent} from 'app/core/modal.component';
import {ModalController} from '@ionic/angular';
import {Group} from '../../../../../../../chat-sdk/src/entities/groups/group';
import {ChatEditModalComponent} from '../chatEditModal/item';
import {AppModalService} from '../../../../../services/appModal.service';
import {ChatInfoContentMediaService} from "./services/chat-info-content-media.service";
import {ListComponent} from "../../../../ui/list/item";
import {ChatInfoContentDocService} from "./services/chat-info-content-doc.service";
import {ChatInfoContentLinkService} from "./services/chat-info-content-link.service";
import {TabsComponent} from "../../../../ui/tabs/item";
import {IGroupFullDataCounter} from "../../../../../../../chat-sdk/src/interfaces/socket.interface";

@Component({
  selector: 'app-chat-info-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatInfoModalComponent extends ModalComponent implements OnInit {
  @ViewChild('list') list: ListComponent;
  @ViewChild('listDoc') listDoc: ListComponent;
  @ViewChild('listLink') listLink: ListComponent;
  @ViewChild('fileTab') fileTab: TabsComponent;
  @ViewChild('tab') tab: TabsComponent;
  group: Group;
  appModalService: AppModalService;
  chatInfoContentMediaService: ChatInfoContentMediaService;
  chatInfoContentDocService: ChatInfoContentDocService;
  chatInfoContentLinkService: ChatInfoContentLinkService;
  cdr: ChangeDetectorRef;
  listFistLoading = true;
  groupFullDataCounter: IGroupFullDataCounter = {
    total: 0,
    media: 0,
    links: 0,
    documents: 0
  };
  loaded = false;

  constructor(
    modalController: ModalController,
    appModalService: AppModalService,
    chatInfoContentMediaService: ChatInfoContentMediaService,
    chatInfoContentDocService: ChatInfoContentDocService,
    chatInfoContentLinkService: ChatInfoContentLinkService,
    cdr: ChangeDetectorRef
  ) {
    super(modalController);

    this.appModalService = appModalService;

    // @todo chat сделать через фабрику сервисов
    this.chatInfoContentMediaService = chatInfoContentMediaService;
    this.chatInfoContentDocService = chatInfoContentDocService;
    this.chatInfoContentLinkService = chatInfoContentLinkService;
    this.cdr = cdr;
  }

  ngOnInit() {
    this.chatInfoContentDocService.groupId = this.group.id;
    this.chatInfoContentMediaService.groupId = this.group.id;
    this.chatInfoContentLinkService.groupId = this.group.id;

    this.group.getFullData().then(data => {
      this.groupFullDataCounter = data.contentTypeCounters;
      this.loaded = true;
      this.cdr.markForCheck();

      setTimeout(() => {
        this.loadItems();
      }, 50);
    });
  }

  loadItems() {
    this.list?.loadItems(true).then(() => {});

    this.listDoc?.loadItems(true).then(() => {});

    this.listLink?.loadItems(true).then(() => {});
  }

  editGroup() {
    this.appModalService.openModal(ChatEditModalComponent, {group: this.group}, 'half', 'half', (data) => {
      console.log('Редактировать информацию');

    });
  }

  changeTab() {
    this.fileTab.updateHeight(0);
    this.tab.updateHeight(100);
  }
}


